import { Injectable, inject } from '@angular/core';
import { EncriptarService } from './encriptar.service';
import { HttpClient } from '@angular/common/http';
import { Parametro } from '../Models/Parametro';
import { eEstadoActivacion, eOrdenacionTerceros, eTipoGrupo, eTipoModalidadFacturas, enumMonedas, enumNivelDetalle, enumPerfilAcceso, enumTipoDocumento, enumTipoOperacion, globalConf } from '../../GlobalConf';
import { db } from 'src/db/db';
import { VariablesGlobalesService } from './variables-globales.service';
import { ErpService } from './API_ALO/erp.service';
import { AMRespuestaGET } from '../Models/RespuestaGET/AMRespuestaGET';
import { EmpresaPresencia } from '../Models/EmpresaPresencia';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, LoadingController, ModalController, Platform, ToastController } from '@ionic/angular/standalone';
import { TitleCasePipe } from '@angular/common';
import { Storage } from '@capacitor/storage';
import { ClienteDTO, ProveedorDTO } from '../Models/ApiV2/Terceros';
import { AlbaranDTO, ArticuloDocumentoApp, FacturaDTO, PedidoDTO } from '../Models/ApiV2/DocumentoDTO';
import { ArticuloDTO, TarifaPreciosDTO, TarifaDescuentosDTO } from '../Models/ApiV2/ArticuloDTO';
import { AspectoDTO } from '../Models/ApiV2/AspectoDTO';
import * as moment from 'moment';
import { Device } from '@capacitor/device';
import { AuditoriaAplicacionesService, DTO_AuditoriaAplicacion } from './API_ALO/auditoriaaplicaciones.service';
import { AMRespuestaPOSTPUT } from '../Models/RespuestaPOSTPUT/AMRespuestaPOSTPUT';
import { DocumentosErpService } from './API_ALO/documentosErp.service';

@Injectable({
  providedIn: 'root'
})
export class ProcesosGlobalesService {
  variablesGlobales = inject(VariablesGlobalesService);
  private servicioEncriptar = inject(EncriptarService);
  private http = inject(HttpClient);
  erpService = inject(ErpService);
  private encriptar = inject(EncriptarService);
  translate = inject(TranslateService);
  loadingCtrl = inject(LoadingController);
  private titlecasePipe = inject(TitleCasePipe);
  private toastController = inject(ToastController);
  platform = inject(Platform);
  servicioAuditoria = inject(AuditoriaAplicacionesService);
  servicioDocumentos = inject(DocumentosErpService);
  modalCtrl = inject(ModalController);
  alertController = inject(AlertController);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

  async procesoPreCargaDatosStorage() {
    await this.cargarArticulosDB()
    await this.cargarArticulosRecientesDB()

    await this.cargarClientesDB()
    await this.cargarClientesRecientesDB()

    await this.cargarProveedoresDB()
    await this.cargarProveedoresRecientesDB()

    await this.cargarPedidosVentaDB()
    await this.cargarPedidosCompraDB()

    await this.cargarFacturasVentaDB()
    await this.cargarFacturasCompraDB()
    await this.cargarFacturasSimplificadasDB()

    await this.cargarAlbaranesVentaDB()
    await this.cargarAlbaranesCompraDB()

    await this.cargarPresupuestosDB()



  }

  /**
  * Método para realizar la petición a ALO solicitanto la lista de parámetros referentes a documentos
  * @returns Lista de los parámetros que devuelve ALO
  */
  obtenerParametrosDocumentos() {
    return this.http.get<Parametro[]>(globalConf.url_api_erp + globalConf.path_Parametros + this.variablesGlobales.empresaActual.GUID_Registro);
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de parámetros referentes a documentos
* @returns Lista de los parámetros que devuelve ALO
*/
  // obtenerParametrosEmpresa(){
  //   return this.http.get<Parametro[]>(globalConf.url_api_erp + globalConf.path_ParametrosEmpresa+this.variablesGlobales.empresaActual.GUID_Registro);
  // }

  async cargarPedidosVentaDB() {
    await db.dbPedidosVenta.toArray().then(pedidosDB => {
      for (let i = 0; i < pedidosDB.length; i++) {
        let arrayPedidosDesencriptados = JSON.parse(this.servicioEncriptar.desencriptar(pedidosDB[i].pedidos))
        this.variablesGlobales.listaPedidosVenta = this.variablesGlobales.listaPedidosVenta.concat(arrayPedidosDesencriptados)
      }
      console.log('Cargados pedidos de indexedDB');
    }).catch(error => console.log('No se ha encontrado la tabla "pedidos" en IndexDB.'))
  }
  async cargarPedidosCompraDB() {
    await db.dbPedidosCompra.toArray().then(pedidosDB => {
      for (let i = 0; i < pedidosDB.length; i++) {
        let arrayPedidosDesencriptados = JSON.parse(this.servicioEncriptar.desencriptar(pedidosDB[i].pedidos))
        this.variablesGlobales.listaPedidosCompra = this.variablesGlobales.listaPedidosCompra.concat(arrayPedidosDesencriptados)
      }
      console.log('Cargados pedidos compra de indexedDB');
    }).catch(error => console.log('No se ha encontrado la tabla "pedidos compra" en IndexDB.'))
  }

  async cargarFacturasVentaDB() {
    await db.dbFacturasVenta.toArray().then(facturasDB => {
      for (let i = 0; i < facturasDB.length; i++) {
        let arrayFacturasDesencriptados = JSON.parse(this.servicioEncriptar.desencriptar(facturasDB[i].facturas))
        this.variablesGlobales.listaFacturasVenta = this.variablesGlobales.listaFacturasVenta.concat(arrayFacturasDesencriptados)
      }
      console.log('Cargados facturas de indexedDB');
    }).catch(error => console.log('No se ha encontrado la tabla "facturas" en IndexDB.'))
  }
  async cargarFacturasCompraDB() {
    await db.dbFacturasCompra.toArray().then(facturasDB => {
      for (let i = 0; i < facturasDB.length; i++) {
        let arrayFacturasDesencriptados = JSON.parse(this.servicioEncriptar.desencriptar(facturasDB[i].facturas))
        this.variablesGlobales.listaFacturasCompra = this.variablesGlobales.listaFacturasCompra.concat(arrayFacturasDesencriptados)
      }
      console.log('Cargados facturas compra de indexedDB');
    }).catch(error => console.log('No se ha encontrado la tabla "facturas compra" en IndexDB.'))
  }

  async cargarFacturasSimplificadasDB() {
    await db.dbFacturasSimplificadas.toArray().then(facturasSimplificadasDB => {
      for (let i = 0; i < facturasSimplificadasDB.length; i++) {
        let arrayFacturasSimplificadasDesencriptados = JSON.parse(this.servicioEncriptar.desencriptar(facturasSimplificadasDB[i].facturas))
        this.variablesGlobales.listaFacturasSimplificadas = this.variablesGlobales.listaFacturasSimplificadas.concat(arrayFacturasSimplificadasDesencriptados)
      }
      console.log('Cargadas facturas simplificadas de indexedDB');
    }).catch(error => console.log('No se ha encontrado la tabla "facturasSimplificadas" en IndexDB.'))
  }

  async cargarAlbaranesVentaDB() {
    await db.dbAlbaranesVenta.toArray().then(albaranesDB => {
      for (let i = 0; i < albaranesDB.length; i++) {
        let arrayAlbaranesDesencriptados = JSON.parse(this.servicioEncriptar.desencriptar(albaranesDB[i].albaranes))
        this.variablesGlobales.listaAlbaranesVenta = this.variablesGlobales.listaAlbaranesVenta.concat(arrayAlbaranesDesencriptados)
      }
      console.log('Cargados albaranes de indexedDB');
    }).catch(error => console.log('No se ha encontrado la tabla "albaranes" en IndexDB.'))
  }

  async cargarAlbaranesCompraDB() {
    await db.dbAlbaranesCompra.toArray().then(albaranesDB => {
      for (let i = 0; i < albaranesDB.length; i++) {
        let arrayAlbaranesDesencriptados = JSON.parse(this.servicioEncriptar.desencriptar(albaranesDB[i].albaranes))
        this.variablesGlobales.listaAlbaranesCompra = this.variablesGlobales.listaAlbaranesCompra.concat(arrayAlbaranesDesencriptados)
      }
      console.log('Cargados albaranes compra de indexedDB');
    }).catch(error => console.log('No se ha encontrado la tabla "albaranes compra" en IndexDB.'))
  }

  async cargarPresupuestosDB() {
    await db.dbPresupuestos.toArray().then(presupuestosDB => {
      for (let i = 0; i < presupuestosDB.length; i++) {
        let arrayPresupuestosDesencriptados = JSON.parse(this.servicioEncriptar.desencriptar(presupuestosDB[i].presupuestos))
        this.variablesGlobales.listaPresupuestos = this.variablesGlobales.listaPresupuestos.concat(arrayPresupuestosDesencriptados)
      }
      console.log('Cargados presupuestos de indexedDB');
    }).catch(error => console.log('No se ha encontrado la tabla "presupuestos" en IndexDB.'))
  }

  async cargarArticulosDB() {
    await db.dbArticulos.toArray().then(articulosDB => {
      for (let i = 0; i < articulosDB.length; i++) {
        let arrayArticulosDesencriptados = JSON.parse(this.servicioEncriptar.desencriptar(articulosDB[i].articulos))
        this.variablesGlobales.listaArticulos = this.variablesGlobales.listaArticulos.concat(arrayArticulosDesencriptados)
      }
      console.log('Cargados articulos de indexedDB');
    }).catch(error => console.log('No se ha encontrado la tabla "articulos" en IndexDB.'))
  }

  async cargarClientesDB() {
    await db.dbClientes.toArray().then(clientesDB => {
      for (let i = 0; i < clientesDB.length; i++) {
        let arrayClientesDesencriptados = JSON.parse(this.servicioEncriptar.desencriptar(clientesDB[i].clientes))
        this.variablesGlobales.listaClientes = this.variablesGlobales.listaClientes.concat(arrayClientesDesencriptados)
      }
      console.log('Cargados clientes de indexedDB. ', this.variablesGlobales.listaClientes);
    }).catch(error => console.log('No se ha encontrado la tabla "clientes" en IndexDB.'))
  }
  async cargarClientesRecientesDB() {
    await db.dbClientesRecientes.toArray().then(clientesDB => {
      for (let i = 0; i < clientesDB.length; i++) {
        let clienteDesencriptado = JSON.parse(this.servicioEncriptar.desencriptar(clientesDB[i].clientes))
        this.variablesGlobales.listaClientesRecientes.push(clienteDesencriptado)
      }
      console.log('Cargados clientes recientes de indexedDB');
    }).catch(error => console.log('No se ha encontrado la tabla "clientes recientes" en IndexDB.'))
  }
  async cargarProveedoresDB() {
    await db.dbProveedores.toArray().then(proveedoresDB => {
      for (let i = 0; i < proveedoresDB.length; i++) {
        let arrayProveedoresDesencriptados = JSON.parse(this.servicioEncriptar.desencriptar(proveedoresDB[i].proveedores))
        this.variablesGlobales.listaProveedores = this.variablesGlobales.listaProveedores.concat(arrayProveedoresDesencriptados)
      }
      console.log('Cargados proveedores de indexedDB. ', this.variablesGlobales.listaProveedores);
    }).catch(error => console.log('No se ha encontrado la tabla "proveedores" en IndexDB.'))
  }

  async cargarProveedoresRecientesDB() {
    await db.dbProveedoresRecientes.toArray().then(proveedoresDB => {
      for (let i = 0; i < proveedoresDB.length; i++) {
        let arrayProveedoresDesencriptados = JSON.parse(this.servicioEncriptar.desencriptar(proveedoresDB[i].proveedores))
        this.variablesGlobales.listaProveedoresRecientes = this.variablesGlobales.listaProveedoresRecientes.concat(arrayProveedoresDesencriptados)
      }
      console.log('Cargados proveedores recientes de indexedDB. ', this.variablesGlobales.listaProveedoresRecientes);
    }).catch(error => console.log('No se ha encontrado la tabla "proveedores recientes" en IndexDB.'))
  }

  async cargarArticulosRecientesDB() {
    await db.dbArticulosRecientes.toArray().then(articulosDB => {
      for (let i = 0; i < articulosDB.length; i++) {
        let articuloDesencriptado = JSON.parse(this.servicioEncriptar.desencriptar(articulosDB[i].articulos))
        this.variablesGlobales.listaArticulosRecientes.push(articuloDesencriptado)
      }
      console.log('Cargados articulos recientes de indexedDB');
    }).catch(error => console.log('No se ha encontrado la tabla "articulos recientes" en IndexDB.'))
  }

  obtenerNombreComercial(idCliente: number): string {
    return this.variablesGlobales.listaClientes.find(cliente => cliente.id == idCliente)?.nombreComercial
  }

  obtenerNombreComercialProveedor(idProveedor: number): string {
    return this.variablesGlobales.listaProveedores.find(proveedor => proveedor.id == idProveedor)?.nombreComercial
  }

  cambiarColorPrimario(color: string): void {
    const primaryRgb = this.hexToRgb(color);  // Convertir de Hex a RGB

    document.documentElement.style.setProperty('--ion-color-primary', color, "important"); // Para modo claro
    document.body.style.setProperty('--ion-color-primary', color, "important"); // Para modo oscuro

    document.documentElement.style.setProperty('--ion-color-primary-rgb', primaryRgb.toString(), "important"); // Para modo claro
    document.body.style.setProperty('--ion-color-primary-rgb', primaryRgb.toString(), "important"); // Para modo oscuro




  }

  // Función para convertir de Hex a RGB
  hexToRgb(hex: string): number[] {
    const bigint = parseInt(hex.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return [r, g, b];
  }

  cambiarColorSecundario(color: string): void {
    const secondaryRgb = this.hexToRgb(color);  // Convertir de Hex a RGB


    document.documentElement.style.setProperty('--ion-color-secondary', color, "important"); // Para modo claro
    document.body.style.setProperty('--ion-color-secondary', color, "important"); // Para modo oscuro

    document.documentElement.style.setProperty('--ion-color-secondary-rgb', secondaryRgb.toString(), "important"); // Para modo claro
    document.body.style.setProperty('--ion-color-secondary-rgb', secondaryRgb.toString(), "important"); // Para modo oscuro


  }

  async cargasInicialesApp() {

    await this.obtenerParametrosAspecto();

    this.obtenerParametrosDocumentos().subscribe((resParametros: Parametro[]) => {
      console.log({ resParametros });
      this.variablesGlobales.parametros = resParametros
      let paramCodigoMoneda = this.variablesGlobales.parametros.find(parametro => parametro.Codigo == 'CodigoMoneda')
      this.variablesGlobales.codigoMonedaALO = enumMonedas[paramCodigoMoneda.Valor]
       let paramIdioma = this.variablesGlobales.parametros.find(parametro => parametro.Codigo == 'ClaveIdioma')
       this.variablesGlobales.idiomaALO = paramIdioma.Valor
      let paramSeparadorDecimal = this.variablesGlobales.parametros.find(parametro => parametro.Codigo == 'SeparadorDecimal')

      if (paramSeparadorDecimal.Valor == ',') {
        this.variablesGlobales.localeMoneda = 'es-ES'
        this.variablesGlobales.optionsInputUnidades.decimalCharacter = ','
        this.variablesGlobales.optionsInputUnidades.digitGroupSeparator = '.'
      } else if (paramSeparadorDecimal.Valor == '.') {
        this.variablesGlobales.localeMoneda = 'en-US'
        this.variablesGlobales.optionsInputUnidades.decimalCharacter = '.'
        this.variablesGlobales.optionsInputUnidades.digitGroupSeparator = ','
      }
      let paramDecimalesEnUnidades = this.variablesGlobales.parametros.find(parametro => parametro.Codigo == 'DecimalesEnUnidades')
      this.variablesGlobales.DecimalesEnUnidades = paramDecimalesEnUnidades.Valor
      this.variablesGlobales.optionsInputUnidades.decimalPlaces = parseInt(paramDecimalesEnUnidades.Valor)

      let paramDecimalesEnMoneda = this.variablesGlobales.parametros.find(parametro => parametro.Codigo == 'DecimalesMoneda')
      this.variablesGlobales.DecimalesEnMoneda = paramDecimalesEnMoneda.Valor
      this.variablesGlobales.optionsInputUnidades.decimalPlaces = parseInt(paramDecimalesEnMoneda.Valor)

      //this.calculoDocumentos.calcularLinesaPrueba()

    })
    if (!this.variablesGlobales.cargaInicialIndexDB) {
      this.variablesGlobales.cargaInicialIndexDB = true;
      let loading
      await this.translate.get('loadings.cargandoDatos').subscribe(async (toastStr: string) => {
        loading = await this.loadingCtrl.create({
          message: this.titlecasePipe.transform(toastStr),
        });
        await loading.present();
        //console.log("Empresa anterior: ", this.variablesGlobales?.empresaAnterior);
        //console.log("Empresa actual: ", this.variablesGlobales?.empresaActual);
        //console.log("PerfilAccesoAnterior: ", this.variablesGlobales.perfilAccesoAnterior);
        //console.log("PerfilAcceso actual: ", this.variablesGlobales.perfilAcceso);

        if (this.variablesGlobales?.empresaAnterior && (this.variablesGlobales.perfilAccesoAnterior == enumPerfilAcceso.USUARIO || this.variablesGlobales.perfilAccesoAnterior == enumPerfilAcceso.VENDEDOR)) {
          if (this.variablesGlobales?.empresaActual?.GUID_Registro == this.variablesGlobales?.empresaAnterior?.GUID_Registro && this.variablesGlobales.perfilAcceso == this.variablesGlobales.perfilAccesoAnterior) {
            console.log("La empresa a la que se accede es la misma que anteriormente y el perfil tambien");
            await this.procesoPreCargaDatosStorage().then(async () => {
              await loading.dismiss();
              //this.cargarClientesALO();
            })
              .catch(async () => {
                await loading.dismiss();
              })
          } else {
            console.log("El perfil de acceso o la empresa a la que se accede es distinta que anteriormente. Limpiar storage!");
            await loading.dismiss();
            await Storage.clear()
            await db.resetDatabase()
            let strEmpresa: string = JSON.stringify(this.variablesGlobales.empresaActual);
            this.servicioEncriptar.guardarEnStorage("empresaAlmacenada", strEmpresa);
            this.servicioEncriptar.guardarEnStorage("perfilAcceso", this.variablesGlobales.perfilAcceso);
            console.log("Recuerdame valor: ", this.variablesGlobales.recuerdameLogin);
            if (this.variablesGlobales.recuerdameLogin) {
              Storage.set({
                key: 'recuerdameLogin',
                value: (this.variablesGlobales.recuerdameLogin.toString())
              });
              let strUsuario: string = JSON.stringify(this.variablesGlobales.usuarioActual);
              if (this.variablesGlobales.perfilAcceso == enumPerfilAcceso.USUARIO) {
                this.servicioEncriptar.guardarEnStorage('CurrentUserALO', strUsuario);
              } else if (this.variablesGlobales.perfilAcceso == enumPerfilAcceso.VENDEDOR) {
                this.servicioEncriptar.guardarEnStorage('CurrentUserPresencia', strUsuario);
              }
            }
            this.cargarClientesALO();
            this.cargarProveedoresALO()
          }
        } else {
          console.log("O empresa anterior o perfil anterior no existe. Empresa Anterior: ", this.variablesGlobales.empresaAnterior, " Perfil Acceso Anterior: ", this.variablesGlobales.perfilAccesoAnterior);
          this.cargarClientesALO();
          this.cargarProveedoresALO()

          await loading.dismiss();
        }
      })

    }

    if (this.variablesGlobales.perfilAcceso == enumPerfilAcceso.VENDEDOR) {
      await this.erpService.obtenerVendedorAlo(enumNivelDetalle.BASICO, this.variablesGlobales.usuarioActual.idVendedor).toPromise().then(async (resAM: AMRespuestaGET) => {
        if (resAM.status == "200") {
          if (resAM.data.length != 0) {
            console.log('Información Vendedor ALO: ', resAM)
            this.variablesGlobales.vendedorActual = resAM.data[0]
          } else {
            console.log('No se ha podido obtener información del vendedor de ALO. RESAM: ', resAM)
            this.variablesGlobales.vendedorActual = null
          }
        }
      })
        .catch(async error => {
          console.error('Error al cargar información del vendedor de ALO. ERROR: ', error)
          this.variablesGlobales.vendedorActual = null
        })
    }

    this.cargarEstadosPedidosALO();
    this.obtenerPeticionesOffline();

  }

  async cargarClientesALO() {
    if (!this.variablesGlobales.leyendoClientes) {
      this.variablesGlobales.leyendoClientes = true

      let pagina: number = 1;
      let registrosPorPagina: number = 1000;
      let ultimaPeticion: boolean = false;
      let indice: number;
      let bloqueLeido: ClienteDTO[] = []
      while (!ultimaPeticion) {
        let listaParametros
        if (this.variablesGlobales.perfilAcceso == enumPerfilAcceso.VENDEDOR) {
          //console.log('Vendedor ACtual: ',this.variablesGlobales.vendedorActual);
          listaParametros = { "estadoActivacion": eEstadoActivacion.Activos, "idsVendedor": this.variablesGlobales.vendedorActual.id, "pagina": pagina, 'registrosPorPagina': registrosPorPagina, "orden": eOrdenacionTerceros.Nombre_ASC };
        } else {
          listaParametros = { "estadoActivacion": eEstadoActivacion.Activos, "pagina": pagina, 'registrosPorPagina': registrosPorPagina, "orden": eOrdenacionTerceros.Nombre_ASC };
        }
        await this.erpService.obtenerClientesAlo(enumNivelDetalle.BASICO, listaParametros).toPromise().then(async (resAM: AMRespuestaGET) => {
          if (resAM.status == "200") {
            if (resAM.data.length != 0) {
              console.log('Lista clientes ALO (' + pagina + '): ', resAM.data)
              // if (pagina == 1) {
              //   this.variablesGlobales.listaClientes = []
              // }
              indice = ((pagina - 1) * registrosPorPagina)
              //this.variablesGlobales.listaClientes = this.variablesGlobales.listaClientes.concat(resAM.data)
              bloqueLeido = resAM.data
              this.variablesGlobales.listaClientes.splice(indice, resAM.data.length, ...bloqueLeido)
              this.variablesGlobales.listaClientes = this.variablesGlobales.listaClientes.concat()
              if (pagina == 1) { db.borrarClientesDB() }
              let arrayClientesEnciptado = this.servicioEncriptar.encriptar(JSON.stringify(bloqueLeido))
              db.guardarClientesDB(arrayClientesEnciptado)
              if (resAM.data.length < registrosPorPagina) {
                ultimaPeticion = true;
                this.variablesGlobales.leyendoClientes = false
                console.log("Cargados todos los clientes ALO");
              } else {
                pagina++
              }

            } else {
              this.variablesGlobales.listaClientes = []
              ultimaPeticion = true;
              this.variablesGlobales.leyendoClientes = false
              db.borrarClientesDB()
              db.borrarClientesRecientesDB()
            }
          } else {
            console.error('Error al cargar clientes de ALO. Status: ', resAM.status, ' message: ', resAM.message)
            this.variablesGlobales.listaClientes = []
            ultimaPeticion = true;
            this.variablesGlobales.leyendoClientes = false
            db.borrarClientesDB()
            db.borrarClientesRecientesDB()
          }
        })
          .catch(async error => {
            console.error('Error al cargar clientes de ALO. ERROR: ', error)
            this.variablesGlobales.listaClientes = []
            ultimaPeticion = true;
            this.variablesGlobales.leyendoClientes = false
            db.borrarClientesDB()
            db.borrarClientesRecientesDB()
          })
      }
    }
  }

  async cargarProveedoresALO() {
    if (!this.variablesGlobales.leyendoProveedores) {
      this.variablesGlobales.leyendoProveedores = true


      let pagina: number = 1;
      let registrosPorPagina: number = 100;
      let ultimaPeticion: boolean = false;
      let indice: number;
      let bloqueLeido: ProveedorDTO[] = []
      while (!ultimaPeticion) {
        let listaParametros
          listaParametros = { "estadoActivacion": eEstadoActivacion.Activos, "pagina": pagina, 'registrosPorPagina': registrosPorPagina, "orden": eOrdenacionTerceros.Nombre_ASC };

        await this.erpService.obtenerProveedoresAlo(enumNivelDetalle.BASICO, listaParametros).toPromise().then(async (resAM: AMRespuestaGET) => {
          if (resAM.status == "200") {
            if (resAM.data.length != 0) {
              console.log('Lista proveedores ALO (' + pagina + '): ', resAM.data)
              indice = ((pagina - 1) * registrosPorPagina)
              bloqueLeido = resAM.data
              this.variablesGlobales.listaProveedores.splice(indice, resAM.data.length, ...bloqueLeido)
              this.variablesGlobales.listaProveedores = this.variablesGlobales.listaProveedores.concat()
              if (pagina == 1) { db.borrarProveedoresDB() }
              let arrayProveedoresEnciptado = this.servicioEncriptar.encriptar(JSON.stringify(bloqueLeido))
              db.guardarProveedoresDB(arrayProveedoresEnciptado)
              if (resAM.data.length < registrosPorPagina) {
                ultimaPeticion = true;
                this.variablesGlobales.leyendoProveedores = false
                console.log("Cargados todos los proveedores ALO");
              } else {
                pagina++
              }

            } else {
              this.variablesGlobales.listaProveedores = []
              ultimaPeticion = true;
              this.variablesGlobales.leyendoProveedores = false
              db.borrarProveedoresDB()
              db.borrarProveedoresRecientesDB()
            }
          } else {
            console.error('Error al cargar clientes de ALO. Status: ', resAM.status, ' message: ', resAM.message)
            this.variablesGlobales.listaProveedores = []
            ultimaPeticion = true;
            this.variablesGlobales.leyendoProveedores = false
            db.borrarProveedoresDB()
            db.borrarProveedoresRecientesDB()
          }
        })
          .catch(async error => {
            console.error('Error al cargar clientes de ALO. ERROR: ', error)
            this.variablesGlobales.listaProveedores = []
            ultimaPeticion = true;
            this.variablesGlobales.leyendoProveedores = false
            db.borrarProveedoresDB()
            db.borrarProveedoresRecientesDB()
          })
      }
    }
  }


  obtenerPeticionesOffline() {
    this.encriptar.obtenerEnStorage('peticionesPendientes')
      .then((res) => {
        if (res) {
          this.variablesGlobales.peticionesPendientes = JSON.parse(res);
          console.log('Peticiones pendientes', this.variablesGlobales.peticionesPendientes);
        }
      })
  }

  buscarIdVendedor(listaEmpresasPresencia: EmpresaPresencia[], empresaALO: EmpresaPresencia): number {
    let idVendedor: number = null;
    if (listaEmpresasPresencia) {
      let empresaPresencia: EmpresaPresencia = listaEmpresasPresencia.find(empresaPresencia => empresaPresencia.GUID_Registro == empresaALO.GUID_Registro)
      if (empresaPresencia) {
        idVendedor = empresaPresencia.PerfilesAplicaciones[0].Id_Tercero;
      }
    }

    return idVendedor;
  }

  async descargarDocumento(documento: FacturaDTO | PedidoDTO | AlbaranDTO) {
    console.log('Descargar documento: ', documento);
    let toast
    await this.translate.get('toast.errorDescargaDocumento').toPromise().then(async (toastStr: string) => {
      toast = await this.toastController.create({
        message: toastStr,
        duration: 1500,
        color: 'danger'
      });
    })

    let loading
    await this.translate.get('loadings.descargaDocumento').toPromise().then(async (loadingStr: string) => {
      loading = await this.loadingCtrl.create({
        message: loadingStr,
      });
      await loading.present();
    })


    this.erpService.getDescargaDocumento(documento.id).toPromise().then(async (resAM: AMRespuestaGET) => {
      if (resAM.status == "200") {
        if (resAM.data.length != 0) {
          let urlDescargaArchivo = new Array(resAM.data)
          console.log('urlDescargaArchivo: ', urlDescargaArchivo[0].toString());
          await loading.dismiss();
          if (this.platform.is('ios')) {
            window.open(urlDescargaArchivo[0].toString(), "_self").focus()
          } else {
            window.open(urlDescargaArchivo[0].toString(), "_blank").focus()
          }
        } else {
          console.log('El enlace de descarga del documento viene vacío. ', resAM);
          await loading.dismiss();
          await toast.present();
        }
      } else {
        console.log('No se ha podido obtener el enlace de descarga de ALO. ', resAM);
        await loading.dismiss();
        await toast.present();
      }
    })
      .catch(async error => {
        console.log('Error al obtener el enlace de descarga de ALO. ERROR: ', error);
        await loading.dismiss();
        await toast.present();
      })
  }

  async obtenerParametrosAspecto() {

    this.encriptar.obtenerEnStorage('colores')
      .then(async (colores: string) => {

        console.log("La carga de colores", colores);


        if (colores && this.variablesGlobales.empresaActual.GUID_Empresa == JSON.parse(colores).guidEmpresa) { //Guardado en storage
          let coloresStorage: { guidEmpresa:string, colorPrimario?: string, colorSecundario?: string } = JSON.parse(colores);

          if (coloresStorage.colorPrimario) {
            this.cambiarColorPrimario(coloresStorage.colorPrimario);
            this.variablesGlobales.colorPrimario = coloresStorage.colorPrimario;
            document.querySelector('meta[name="theme-color"]').setAttribute('content', coloresStorage.colorPrimario);
            coloresStorage.colorPrimario = this.variablesGlobales.colorPrimario;
          }
          if (coloresStorage.colorSecundario) {
            this.cambiarColorSecundario(coloresStorage.colorSecundario);
            this.variablesGlobales.colorSecundario = coloresStorage.colorPrimario;
            coloresStorage.colorPrimario = this.variablesGlobales.colorSecundario;
          }
          // await this.encriptar.guardarEnStorage('colores', JSON.stringify(colores))


        } else {
          this.erpService.obtenerAspecto().toPromise() // No está guardado, hay que obtenerlo
            .then(next => {
              let aspecto: AspectoDTO[] = next.data
              console.log("Aspecto ", aspecto)
              let coloresGuardar: {guidEmpresa:string, colorPrimario?: string, colorSecundario?: string, } = {guidEmpresa:this.variablesGlobales.empresaActual.GUID_Empresa, colorPrimario: "", colorSecundario: "" };
              aspecto.forEach(async parametro => {


                if (parametro.codigo == 'ColorPrimario') {
                  this.cambiarColorPrimario("#" + parametro.valor);
                  this.variablesGlobales.colorPrimario = "#" + parametro.valor
                  document.querySelector('meta[name="theme-color"]').setAttribute('content', "#" + parametro.valor);
                  coloresGuardar.colorPrimario = this.variablesGlobales.colorPrimario;
                }
                if (parametro.codigo == 'ColorSecundario') {
                  this.cambiarColorSecundario("#" + parametro.valor)
                  this.variablesGlobales.colorSecundario = "#" + parametro.valor
                  coloresGuardar.colorSecundario = this.variablesGlobales.colorSecundario;
                }

              })
                this.encriptar.guardarEnStorage('colores', JSON.stringify(coloresGuardar)).then(() => {
                console.log("Colores guardados",coloresGuardar);

              },
                error => {
                  console.log("Error Aspecto ", error)

                }
              )
            })

        }
      })



  }

  obtenerTarifaPrecioArticulo(articulo: ArticuloDTO, tipoOperacion:eTipoGrupo, tarifaPrecioPredeterminada: TarifaPreciosDTO, cliente: ClienteDTO, fechaDocumento: Date, numUnidades?: number): [TarifaPreciosDTO, boolean] {

    if (articulo?.preciosEspeciales && tipoOperacion == eTipoGrupo.CL) {
      console.log('El articulo tiene precios especiales!');

      let arrayPreciosEspeciales: TarifaPreciosDTO[] = []
      arrayPreciosEspeciales = articulo?.preciosEspeciales?.filter((precioEspecial: TarifaPreciosDTO) => precioEspecial?.entidad?.id == cliente?.id)
      console.log('Precios especiales para el articulo: ', articulo.id, ' y el cliente: ', cliente.id);
      if (arrayPreciosEspeciales != null && arrayPreciosEspeciales.length > 0) {
        arrayPreciosEspeciales = arrayPreciosEspeciales.filter((precioEspecial: TarifaPreciosDTO) => (fechaDocumento >= new Date(precioEspecial.fechaInicial)) && (fechaDocumento <= new Date(precioEspecial.fechaFinal)))
        arrayPreciosEspeciales.sort((a, b) => a.fechaInicial < b.fechaInicial ? 1 : -1);

        if (arrayPreciosEspeciales && arrayPreciosEspeciales.length > 0) {
          for (let i = 0; i < arrayPreciosEspeciales.length; i++) {
            if (arrayPreciosEspeciales[i].tarifaEspecial && numUnidades >= arrayPreciosEspeciales[i].cantidadInicial) {
              let precioEspecial = articulo.preciosGenerales.find((precioGeneral: TarifaPreciosDTO) => precioGeneral.entidad.id == arrayPreciosEspeciales[i].tarifaEspecial.id)
              //precioEspecial = arrayPreciosEspeciales[i]
              console.log('Precio articulo para cliente con tarifa especial: ', precioEspecial);
              return [precioEspecial, true]
            } else if (numUnidades >= arrayPreciosEspeciales[i].cantidadInicial) {
              let precioEspecial = arrayPreciosEspeciales[i];
              console.log('Precio articulo para cliente con precio especial: ', precioEspecial);
              return [precioEspecial, true]
            }
          }
        }


      }
    }

    let arrayPreciosPredeterminados: TarifaPreciosDTO[] = []
    arrayPreciosPredeterminados = articulo?.preciosGenerales?.filter((precioGeneral: TarifaPreciosDTO) => precioGeneral?.entidad?.id == tarifaPrecioPredeterminada?.id && precioGeneral.tipoOperacion == tipoOperacion)

    if (arrayPreciosPredeterminados != null && arrayPreciosPredeterminados.length > 0) {
      arrayPreciosPredeterminados = arrayPreciosPredeterminados.filter((precioGeneral: TarifaPreciosDTO) => (fechaDocumento >= new Date(precioGeneral.fechaInicial)) && (fechaDocumento <= new Date(precioGeneral.fechaFinal)))
      arrayPreciosPredeterminados = arrayPreciosPredeterminados.sort(function (a, b) { return (new Date(a.fechaInicial) < new Date(b.fechaInicial)) ? 1 : ((new Date(b.fechaInicial) < new Date(a.fechaInicial)) ? -1 : 0) })

      let precioPredeterminado = arrayPreciosPredeterminados[0]
      return [precioPredeterminado, false]
    }else {
      return [null, false]
    }
  }

  obtenerTarifaDescuentoArticulo(articulo: ArticuloDTO, tarifaDescuentoPredeterminada: TarifaDescuentosDTO, cliente: ClienteDTO, fechaDocumento: Date, numUnidades?: number): [TarifaDescuentosDTO, boolean] {
    if (articulo?.descuentosEspeciales) {
      console.log('El articulo tiene descuentos especiales!');

      let arrayDescuentosEspeciales: TarifaDescuentosDTO[] = []
      arrayDescuentosEspeciales = articulo?.descuentosEspeciales?.filter((descuentoEspecial: TarifaDescuentosDTO) => descuentoEspecial?.entidad?.id == cliente?.id)
      console.log('Descuentos especiales para el articulo: ', articulo.id, ' y el cliente: ', cliente.id);
      if (arrayDescuentosEspeciales != null && arrayDescuentosEspeciales.length > 0) {
        arrayDescuentosEspeciales = arrayDescuentosEspeciales.filter((descuentoEspecial: TarifaDescuentosDTO) => (fechaDocumento >= new Date(descuentoEspecial.fechaInicial)) && (fechaDocumento <= new Date(descuentoEspecial.fechaFinal)))
        arrayDescuentosEspeciales.sort((a, b) => a.fechaInicial < b.fechaInicial ? 1 : -1);
        if (arrayDescuentosEspeciales && arrayDescuentosEspeciales.length > 0) {
          for (let i = 0; i < arrayDescuentosEspeciales.length; i++) {
            if (numUnidades >= arrayDescuentosEspeciales[i].cantidadInicial) {
              let descuentoEspecial = arrayDescuentosEspeciales[i];
              console.log('Descuento articulo para cliente con desceunto especial: ', descuentoEspecial);
              return [descuentoEspecial, true]
            }
          }
        }


      }
    }

    let descuentoPredeterminado: any = null
    descuentoPredeterminado = articulo?.descuentosGenerales?.find((descuentoGeneral: TarifaDescuentosDTO) => descuentoGeneral?.entidad?.id == tarifaDescuentoPredeterminada?.id)
    console.log({ descuentoPredeterminado });

    return [descuentoPredeterminado, false]
  }

  async registrarLogAplicacion(usuario: string, idUsuario:number, idRegistroFichero:number, perfil: string, operacion: string, texto?: string) {
    if(globalConf.auditoriaActivada){
      let fecha = moment().format();
      let dispositivo = await Device.getInfo();
      let dispositivoConPlataforma = JSON.parse(JSON.stringify(dispositivo))
      dispositivoConPlataforma.plataforma = this.variablesGlobales.plataforma

      let ipUsuario: string = ''
      // fetch("https://checkip.amazonaws.com/").then(res => res.text()).then(data => {
      //   ipUsuario = data
      // })
      // await this.http.get("http://api.ipify.org/?format=json").toPromise().then((res: any) => {
      //   ipUsuario = res.ip;
      // });
      let logAGrabar:DTO_AuditoriaAplicacion = {
        fechaOperacion: fecha,
        operacion: operacion,
        texto: texto,
        fecha: fecha,
        ipUsuario: ipUsuario,
        usuario:usuario,
        idUsuario: idUsuario,
        idRegistroFichero: idRegistroFichero,
        perfil:perfil,
        dispositivo: JSON.stringify(dispositivoConPlataforma)
      }

      this.servicioAuditoria.postLogsAuditoriaAplicaciones(logAGrabar).toPromise().then((resPOSTLog:AMRespuestaPOSTPUT) => {
        if(resPOSTLog.ok){
          console.log('Log grabado corecctamente');

        }else {
          console.log('Error al grabar el log: ',resPOSTLog);

        }
      })
      .catch(error => {
        console.log('Error al grabar el log: ',error);})
    }


  }

  cargarEstadosPedidosALO(){
    this.servicioDocumentos.obtenerEstadosPedidoAlo('venta','').toPromise().then(async (resAM: AMRespuestaGET) => {
      console.log({resAM})
      if (resAM.status == "200") {
        console.log('Cargados estados de pedido de ALO: ',resAM.data);
        this.variablesGlobales.estadosPedidosALO = resAM.data;
      }else{
        this.variablesGlobales.estadosPedidosALO = []
        console.log('Error al cargar estados de pedido de ALO: ',resAM);
      }
    })
    .catch(async error => {
      console.error('Error al cargar estados de pedido de ALO. ERROR: ', error)
      this.variablesGlobales.estadosPedidosALO = []
    })
  }

  async anadirAlCarrito(articuloSeleccionado: ArticuloDTO, data, tarifaPrecioPredeterminada, tarifaDescuentoPredeterminada){
    console.log('this.variablesGlobales.documentoActual.tercero: ',this.variablesGlobales.documentoActual.tercero);

    if(this.variablesGlobales.documentoActual.tercero?.condicionesEconomicas && this.variablesGlobales.documentoActual.tercero?.condicionesEconomicas[0]?.tarifaPrecios){
      this.variablesGlobales.documentoActual.tarifaPrecioPredeterminada = this.variablesGlobales.documentoActual.tercero.condicionesEconomicas[0].tarifaPrecios;
    }else{
      this.variablesGlobales.documentoActual.tarifaPrecioPredeterminada = tarifaPrecioPredeterminada;
    }
    if(this.variablesGlobales.documentoActual.tercero?.condicionesEconomicas && this.variablesGlobales.documentoActual.tercero?.condicionesEconomicas[0]?.tarifaDescuentos){
      this.variablesGlobales.documentoActual.tarifaDescuentoPredeterminada = this.variablesGlobales.documentoActual.tercero?.condicionesEconomicas[0]?.tarifaDescuentos;
    }else{
      this.variablesGlobales.documentoActual.tarifaDescuentoPredeterminada = tarifaDescuentoPredeterminada;
    }

    let articuloDocumentoApp:ArticuloDocumentoApp = new ArticuloDocumentoApp();
    articuloDocumentoApp.articulo = articuloSeleccionado;
    articuloDocumentoApp.numUnidades = data.data.numUnidades;
    articuloDocumentoApp.lote = data.data.lote;
    articuloDocumentoApp.listaLotes = data.data.listaLotes;

    let [tarifaPrecioArticulo,precioEspecial] = await this.obtenerTarifaPrecioArticulo(articuloSeleccionado,this.variablesGlobales.documentoActual.tipoOperacion,this.variablesGlobales.documentoActual.tarifaPrecioPredeterminada, this.variablesGlobales.documentoActual.tercero, new Date(this.variablesGlobales.documentoActual.fecha), data.data.numUnidades);
    if(precioEspecial){
      if(tarifaPrecioArticulo?.iva){
        articuloDocumentoApp.precioEspecialIva = tarifaPrecioArticulo?.precio ?? 0
        articuloDocumentoApp.precioEspecial = null
      }else{
        articuloDocumentoApp.precioEspecial = tarifaPrecioArticulo?.precio ?? 0
        articuloDocumentoApp.precioEspecialIva = null
      }
    }else if(tarifaPrecioArticulo == null){
      if(tarifaPrecioPredeterminada?.iva){
        articuloDocumentoApp.precioPredeterminadoIva = tarifaPrecioArticulo?.precio ?? 0
        articuloDocumentoApp.precioPredeterminado = null
      }else{
        articuloDocumentoApp.precioPredeterminado = tarifaPrecioArticulo?.precio ?? 0
        articuloDocumentoApp.precioPredeterminadoIva = null
      }
    }else {
      if(tarifaPrecioArticulo?.iva){
        articuloDocumentoApp.precioPredeterminadoIva = tarifaPrecioArticulo?.precio ?? 0
        articuloDocumentoApp.precioPredeterminado = null
      }else{
        articuloDocumentoApp.precioPredeterminado = tarifaPrecioArticulo?.precio ?? 0
        articuloDocumentoApp.precioPredeterminadoIva = null
      }
    }

    let [tarifaDescuentoArticulo,descuentoEspecial] = await this.obtenerTarifaDescuentoArticulo(articuloSeleccionado, this.variablesGlobales.documentoActual.tarifaDescuentoPredeterminada, this.variablesGlobales.documentoActual.tercero, new Date(this.variablesGlobales.documentoActual.fecha), data.data.numUnidades);
    if(descuentoEspecial){
      articuloDocumentoApp.descuentoEspecial = tarifaDescuentoArticulo?.descuento1 | 0
    }else{
      articuloDocumentoApp.descuentoPredeterminado = tarifaDescuentoArticulo?.descuento1 | 0
    }

    this.variablesGlobales.documentoActual.listaArticulos.push(articuloDocumentoApp);

  }

  async crearDocumento(tipoDocumento: enumTipoDocumento, tipoOperacion: enumTipoOperacion, tercero?: ClienteDTO | ProveedorDTO, modalidadFactura?: eTipoModalidadFacturas){
    console.log('Crear documento. Tipo Documento: ', tipoDocumento, ' tipoOperacion: ', tipoOperacion, ' tercero: ', tercero, ' modalidadFactura: ', modalidadFactura);
    
    let modalCrearDocumento
    if (this.variablesGlobales.plataforma == 'movil') {
      modalCrearDocumento = await this.modalCtrl.create({
        component: (await import('src/app/components/modal-crear-documento/modal-crear-documento.component')).ModalCrearDocumentoComponent,
        mode: 'ios',
        cssClass: 'modalCrearDocumento',
        id: 'modalCrearDocumento',
        componentProps: {
          tipoDocumento: tipoDocumento,
          tipoOperacion: tipoOperacion,
          tercero: tercero,
          modalidadFactura: modalidadFactura
        }
      });
    } else {
      modalCrearDocumento = await this.modalCtrl.create({
        component: (await import('src/app/components/modal-crear-documento/modal-crear-documento.component')).ModalCrearDocumentoComponent,
        mode: 'ios',
        id: 'modalCrearDocumento',
        componentProps: {
          tipoDocumento: tipoDocumento,
          tipoOperacion: tipoOperacion,
          tercero: tercero,
          modalidadFactura: modalidadFactura
        }
      });
    }
    await modalCrearDocumento.present();
      modalCrearDocumento.onDidDismiss().then(data => {
        console.log('Cerrado modal crear documento');

      })
  }

  async crearArticulo(crearServicio: boolean) {

    let modal = await this.modalCtrl.create({
      component: (await import('src/app/components/crear-articulo/crear-articulo.component')).CrearArticuloComponent,
      cssClass: 'modalCrearArticulo',
      componentProps: {
        servicio: crearServicio
      }
    })
    modal.present();

    // const { role } = await modal.onWillDismiss();
    // if (role === 'clienteCreadoCorrectamente') {
    //   this.cargarClientesALO(true);
    // }
  }

  async alertEliminarDocumento(editar: boolean): Promise<boolean> {
    if (this.variablesGlobales.documentoEnCurso) {
      let headerAlert: string;
      let mensajeAlert: string;
      let btnAceptar: string;
      let btnEliminar: string;
      await this.translate.get('alert.documentoEnCurso.header').toPromise().then((resTranslate: string) => {
        headerAlert = resTranslate
      })
      if(editar){
        await this.translate.get('alert.documentoEnCurso.mensaje').toPromise().then((resTranslate: string) => {
          mensajeAlert = resTranslate
          mensajeAlert[0].toUpperCase() + mensajeAlert.substr(1).toLowerCase()
        })
      }
      await this.translate.get('alert.documentoEnCurso.aceptar').toPromise().then((resTranslate: string) => {
        btnAceptar = resTranslate
      })
      await this.translate.get('alert.documentoEnCurso.eliminar').toPromise().then((resTranslate: string) => {
        btnEliminar = resTranslate
      })
      return new Promise(async (resolve) => {
        const alert = await this.alertController.create({
          header: this.titlecasePipe.transform(headerAlert),
          message: mensajeAlert,
          buttons: [
            {
              text: btnAceptar,
              handler: async data => {
                resolve(false);
              }
            },
            {
              text: btnEliminar,
              cssClass: 'danger',
              handler: async data => {
                console.log('Borrar documento actual');
                await this.servicioEncriptar.eliminarLocalStorage('documentoActual')
                this.variablesGlobales.documentoEnCurso = false
                this.variablesGlobales.documentoActual = null
                resolve(true);
              }
            }
          ],
        });
        await alert.present();
      })
    }
    return true;
  }

}
